import { CustomQueryOptions } from '@/common/types_and_interfaces.ts'
import { queryOptions } from '@tanstack/react-query'
import { fetchScholarshipAwards, getAcademicTerms } from './api'
import { GetAcademicTermsParams, GetScholarshipAwardsParams } from './types'
import { AcademicTermProgramArray, ScholarshipAwardsResponse } from './schema'

export class ScholarshipAwardHistoryQueries {
  public static fetchAwards(
    params: GetScholarshipAwardsParams,
    options: CustomQueryOptions<ScholarshipAwardsResponse> = {}
  ) {
    return queryOptions({
      queryKey: ['scholarship-award-history', params],
      queryFn: () => fetchScholarshipAwards(params),
      ...options,
    })
  }

  public static getAcademicTerms(
    params: GetAcademicTermsParams,
    options: CustomQueryOptions<AcademicTermProgramArray> = {}
  ) {
    return queryOptions({
      queryKey: ['academic-terms', params],
      queryFn: () => getAcademicTerms(params),
      ...options,
    })
  }
}
